import { PolicyData, PolicyTemplate } from '../../../../types/policies';

export const getPolicyFieldsFromTemplate = (template: PolicyTemplate): Partial<PolicyData> => {
    const {
        id,
        description,
        policyName,
        isFavorite,
        editableFields,
        typeId,
        supportedActions,
        supportedProtocols,
        authTypes,
        spns,
        risks,
        ...policyData
    } = template;

    return policyData;
};
